import React from 'react';
import { withTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { METRIC_CODE } from '../../../core/constants/common';




const Analytics = ({ t }) => {

  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = '0' + (currentDate.getMonth() + 1);
  let frequencyParam = year + '-' + month + '-01';

  const energyProduced = 'analytics_report/302-1/' + frequencyParam + '/EnergyProduced';
  const energyProducedInside = 'analytics_report/302-1/' + frequencyParam;
  const energyProducedOutside = 'analytics_report/302-2/' + frequencyParam;

  // const [frequencyParam, setFrequencyparam] = useState("");


  useEffect(() => {
    findFrequencyParam();
  }, []);
  const findFrequencyParam = () => {
    console.log(frequencyParam);
    // setFrequencyparam(frequencyParam);
  }

  const setMetricCode = (id) => {
    localStorage.setItem(METRIC_CODE, id);
  }
  return (
    <div>
      <div className="List_header">
        <h5 className="MH">{t("Analytics.label")}</h5>
      </div>
      <div className="Analytics-value_view">

        <div className="row m-0">
          <div className="col-lg-3 p-2 RL_01">
            <div className=" mt-2 Analytics-value_head">
              <h6 className="m-0">Environmental</h6>
            </div>
            <div className="Analytics-value_body">
              <ul>
                <li>
                  <div className="AnalyticstList_box">
                    <h6>
                      <a href={energyProduced} onClick={() => { setMetricCode("302-1") }}>Energy produced</a>
                    </h6>
                    {/* <p>
                      test
                    </p> */}

                  </div>
                </li>
                <li>
                  <div className="AnalyticstList_box">
                    <h6>
                      <a href={energyProducedInside} onClick={() => { setMetricCode("302-1") }}>Energy consumption with in the organization</a>
                    </h6>


                  </div>
                </li>
                <li>
                  <div className="AnalyticstList_box">
                    <h6>
                      <a href={energyProducedOutside} onClick={() => { setMetricCode("302-2") }}>Energy consumption outside of the organization</a>
                    </h6>
                    {/* <p>
                      test
                    </p> */}

                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-3 p-2 RL_02">
            <div className=" mt-2 Analytics-value_head">
              <h6 className="m-0">Social</h6>
            </div>
            <div className="Analytics-value_body">
              <ul>
                <li>
                  <div className="AnalyticstList_box">
                    <h6>
                      <a href="#">Workforce type</a>
                    </h6>
                  </div>
                </li>
                <li>
                  <div className="AnalyticstList_box">
                    <h6>
                      <a href="#">Diversity of employees</a>
                    </h6>
                  </div>
                </li>
                <li>
                  <div className="AnalyticstList_box">
                    <h6>
                      <a href="#">New employees hired</a>
                    </h6>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-3 p-2 RL_03">
            <div className=" mt-2 Analytics-value_head">
              <h6 className="m-0">Governance</h6>
            </div>
            <div className="Analytics-value_body">
              <ul>
                <li>
                  <div className="AnalyticstList_box">
                    <h6>
                      <a href="#">Economic value distributed</a>
                    </h6>
                  </div>
                </li>
                <li>
                  <div className="AnalyticstList_box">
                    <h6>
                      <a href="#">Direct economic value generated and distributed</a>
                    </h6>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div >
      </div >
    </div >
  );
};

export default withTranslation()(Analytics);